import { render, staticRenderFns } from "./PatientAddressTableList.vue?vue&type=template&id=c7e9d08a&scoped=true&"
import script from "./PatientAddressTableList.vue?vue&type=script&lang=js&"
export * from "./PatientAddressTableList.vue?vue&type=script&lang=js&"
import style0 from "./PatientAddressTableList.vue?vue&type=style&index=0&id=c7e9d08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e9d08a",
  null
  
)

export default component.exports